<template>
  <el-dialog
    append-to-body
    width="600px"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title">
        {{ info && info.tag_id ? "编辑" : "新增" }}标签
      </div>
    </template>
    <el-form
      ref="elFormDomUploadDialog"
      label-width="120px"
      :model="form.data"
      :rules="form.rules"
    >
      <el-row type="flex" style="justify-content: center">
        <el-col :span="24">
          <el-form-item label="标签:" prop="tag_id">
            <el-select v-model="form.data.tag_id" clearable filterable>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="item in options"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          v-loading="btnLoading"
          :disabled="btnLoading"
          type="primary"
          @click="conFirm"
          >保存</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      info: {},
      btnLoading: false,
      visible: false,
      options: [],
      form: {
        data: {
          tag_id: "",
        },
        rules: {
          tag_id: [{ required: true, message: "必填项", trigger: "blur" }],
        },
      },
    };
  },
  methods: {
    toggle(val) {
      this.visible = val;
    },
    getDetail(row) {
      this.info = row;
      this.form.data.tag_id = row.tag_id || "";
      this.getTags();
    },
    getTags() {
      this.$http
        .get("/admin/company/tagList", { params: { page: 1, count: 9999 } })
        .then((res) => {
          if (res.code === 1) {
            this.options = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    reset() {
      this.visible = false;
      this.$nextTick(() => {
        this.$refs.elFormDomUploadDialog.resetFields();
      });
    },
    conFirm() {
      this.$refs.elFormDomUploadDialog.validate((valid) => {
        if (valid) {
          let params = {
            tag_id: this.form.data.tag_id,
            id: this.info.id,
          };
          this.btnLoading = true;
          this.$http
            .post("/admin/company/setTag", params)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功");
                this.reset();
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
  },
};
</script>